// extracted by mini-css-extract-plugin
module.exports = {"section2":"styles_section2__2jTF0"};